/* ALERT COLORS */
import type {Tokens} from '../../ThemeProvider';
import {jdGreen} from '../../themes';

export type FuelAlertVariant = 'info' | 'success' | 'warning' | 'error';
export type FuelAlertShade = 'background' | 'icon' | 'border';

const capitalize = <T extends string>(value: T): Capitalize<T> => `${value.charAt(0).toUpperCase()}${value.slice(1)}` as Capitalize<T>;

const getColorKey = (variant: FuelAlertVariant, shade: FuelAlertShade): keyof typeof jdGreen.tokens => `FuelColorAlert${capitalize(variant)}${capitalize(shade)}`;

export const getAlertColor = (
    tokens: Tokens,
    alertVariant?: FuelAlertVariant,
    alertShade?: FuelAlertShade
): string => {
    const variant: FuelAlertVariant = alertVariant ?? 'info';
    const shade: FuelAlertShade = alertShade ?? 'background';

    const colorKey = getColorKey(variant, shade);

    return jdGreen.tokens[colorKey];
};
